// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/components/PostgreSQLComponents.css */

/* ============================================
   ОСНОВНЫЕ СТИЛИ ДЛЯ PostgreSQL MANAGER
============================================ */

.postgresql-container {
  padding: 24px;
  max-width: 1600px;
  margin: 0 auto;
}

.postgresql-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-left h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
}

.header-left h2 i {
  margin-right: 12px;
  color: #336791;
}

.server-status {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  background: #f8f9fa;
}

.server-status.healthy {
  color: #28a745;
  background: #e8f5e9;
}

.server-status.unhealthy {
  color: #dc3545;
  background: #ffebee;
}

.server-status i {
  margin-right: 6px;
}

.create-db-btn {
  background: linear-gradient(135deg, #336791 0%, #2c5a7a 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.create-db-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

.create-db-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #95a5a6;
}

/* ============================================
   СТАТИСТИКА СЕРВЕРА
============================================ */

.server-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  transition: all 0.3s;
}

.stat-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transform: translateY(-2px);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
}

.stat-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.stat-label {
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.2;
}

/* ============================================
   ФИЛЬТР ПО КОНТЕЙНЕРАМ
============================================ */

.filter-section {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.filter-section label {
  font-weight: 500;
  color: #495057;
}

.container-filter {
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  min-width: 250px;
  background: white;
}

/* ============================================
   СЕТКА БАЗ ДАННЫХ
============================================ */

.databases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

/* ============================================
   ПУСТОЕ СОСТОЯНИЕ
============================================ */

.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.empty-icon {
  color: #dee2e6;
  margin-bottom: 20px;
}

.empty-state h3 {
  color: #2c3e50;
  margin-bottom: 8px;
}

.empty-state p {
  color: #6c757d;
  margin-bottom: 24px;
}

.create-first-db-btn {
  background: linear-gradient(135deg, #28a745 0%, #218838 100%);
  color: white;
  border: none;
  padding: 12px 28px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.create-first-db-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

.warning-message {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

.warning-message i {
  font-size: 24px;
}

/* ============================================
   ИНФОРМАЦИЯ О БЕЗОПАСНОСТИ
============================================ */

.security-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 24px;
  margin-top: 40px;
}

.info-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  gap: 16px;
  border: 1px solid #e9ecef;
}

.info-card i {
  font-size: 32px;
  color: #336791;
}

.info-card h4 {
  margin: 0 0 8px 0;
  color: #2c3e50;
}

.info-card p {
  margin: 0;
  color: #6c757d;
  line-height: 1.5;
}

/* ============================================
   КАРТОЧКА БАЗЫ ДАННЫХ
============================================ */

.database-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  overflow: hidden;
  transition: all 0.3s;
  border: 1px solid #e9ecef;
}

.database-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transform: translateY(-2px);
}

.database-card.active {
  border-left: 4px solid #28a745;
}

.database-card.error {
  border-left: 4px solid #dc3545;
}

.card-header {
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e9ecef;
}

.db-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: linear-gradient(135deg, #336791 0%, #2c5a7a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.db-info {
  flex: 1 1;
  min-width: 0;
}

.db-name {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 6px;
}

.db-alias {
  color: #6c757d;
  font-size: 13px;
  cursor: help;
}

.db-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}

.db-container {
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 4px;
}

.db-container i {
  font-size: 12px;
}

.db-status {
  font-weight: 500;
}

.expand-btn {
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.expand-btn:hover {
  background: #f8f9fa;
  color: #336791;
}

.card-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 16px;
  background: #f8f9fa;
}

.stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.stat i {
  color: #6c757d;
  margin-bottom: 4px;
  font-size: 14px;
}

.stat-value {
  font-weight: 600;
  color: #2c3e50;
  font-size: 16px;
}

.stat-label {
  font-size: 11px;
  color: #6c757d;
  margin-top: 2px;
}

.card-details {
  padding: 16px;
  border-top: 1px solid #e9ecef;
  background: white;
}

.details-section {
  margin-bottom: 16px;
}

.details-section h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
}

.details-grid {
  display: grid;
  gap: 8px;
}

.detail-row {
  display: flex;
  font-size: 13px;
}

.detail-label {
  width: 120px;
  color: #6c757d;
}

.detail-value {
  flex: 1 1;
  color: #2c3e50;
  font-family: monospace;
}

.db-description {
  margin: 0;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 6px;
  color: #495057;
  font-size: 13px;
  line-height: 1.5;
}

.security-badge {
  background: #e8f4f8;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #0d47a1;
}

.security-badge i {
  font-size: 18px;
}

.card-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.action-btn {
  padding: 10px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.reset-password-btn {
  background: #e3f2fd;
  color: #0d47a1;
}

.reset-password-btn:hover:not(:disabled) {
  background: #bbdefb;
}

.reset-password-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.delete-btn {
  background: #ffebee;
  color: #c62828;
}

.delete-btn:hover:not(:disabled) {
  background: #ffcdd2;
}

.delete-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================
   МОДАЛЬНОЕ ОКНО
============================================ */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2);
}

.postgres-modal {
  max-width: 600px;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}

.modal-header h3 {
  margin: 0;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 10px;
}

.modal-header h3 i {
  color: #336791;
}

.close-modal-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6c757d;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s;
}

.close-modal-btn:hover:not(:disabled) {
  background: #f8f9fa;
  color: #dc3545;
}

.close-modal-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================
   ФОРМЫ
============================================ */

form {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #495057;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #336791;
  box-shadow: 0 0 0 3px rgba(51, 103, 145, 0.1);
}

.form-group input:disabled,
.form-group select:disabled,
.form-group textarea:disabled {
  background: #e9ecef;
  cursor: not-allowed;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.input-hint {
  display: block;
  margin-top: 4px;
  color: #6c757d;
  font-size: 12px;
}

.container-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  background: white;
}

.container-info-hint {
  margin-top: 8px;
  padding: 8px 12px;
  background: #e3f2fd;
  border-radius: 6px;
  font-size: 13px;
  color: #0d47a1;
  display: flex;
  align-items: center;
  gap: 8px;
}

.error-message {
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-box {
  background: #e7f3ff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
}

.info-box i {
  font-size: 24px;
  color: #336791;
}

.info-box.important {
  background: #fff3e0;
  border-left: 4px solid #ff9800;
}

.info-box.important i {
  color: #ff9800;
}

.info-box ul {
  margin: 8px 0 0 0;
  padding-left: 20px;
}

.info-box li {
  margin: 4px 0;
  color: #495057;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.cancel-btn {
  padding: 10px 20px;
  border: 1px solid #dee2e6;
  background: white;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-btn:hover:not(:disabled) {
  background: #f8f9fa;
}

.submit-btn {
  padding: 10px 24px;
  background: linear-gradient(135deg, #336791 0%, #2c5a7a 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================
   ПРОГРЕСС СОЗДАНИЯ
============================================ */

.creation-progress {
  text-align: center;
  padding: 40px 20px;
}

.progress-spinner {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto 30px;
}

.progress-spinner .fa-database {
  color: #336791;
}

.progress-spinner .fa-cog {
  position: absolute;
  bottom: -10px;
  right: -10px;
  color: #ff9800;
}

.cog-spin {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.progress-text h4 {
  color: #2c3e50;
  margin-bottom: 8px;
}

.progress-text p {
  color: #6c757d;
  margin-bottom: 30px;
}

.progress-steps {
  max-width: 400px;
  margin: 0 auto;
}

.progress-step-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  text-align: left;
}

.step-indicator {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e9ecef;
  transition: all 0.3s;
}

.step-indicator.active {
  background: #28a745;
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.2);
}

.step-label {
  color: #495057;
  font-size: 14px;
}

/* ============================================
   УСПЕШНОЕ СОЗДАНИЕ
============================================ */

.creation-success {
  text-align: center;
  padding: 20px;
}

.success-icon {
  color: #28a745;
  font-size: 64px;
  margin-bottom: 20px;
}

.database-info {
  text-align: left;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
}

.database-info h4 {
  margin: 0 0 16px 0;
  color: #2c3e50;
  text-align: center;
}

.info-block {
  margin-bottom: 20px;
}

.info-row {
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  width: 120px;
  font-weight: 500;
  color: #6c757d;
}

.info-value {
  flex: 1 1;
  color: #2c3e50;
  font-family: monospace;
}

.security-note {
  background: #e3f2fd;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.security-note i {
  font-size: 24px;
  color: #0d47a1;
}

.security-note strong {
  display: block;
  margin-bottom: 4px;
  color: #0d47a1;
}

.security-note p {
  margin: 4px 0;
  color: #1a237e;
  font-size: 14px;
}

.security-note .small {
  font-size: 13px;
  opacity: 0.8;
}

/* ============================================
   ДИАЛОГ ПОДТВЕРЖДЕНИЯ УДАЛЕНИЯ
============================================ */

.confirm-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.confirm-dialog-content {
  background: white;
  border-radius: 12px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  text-align: center;
}

.confirm-icon {
  color: #ffc107;
  font-size: 48px;
  margin-bottom: 16px;
}

.confirm-dialog h4 {
  margin: 0 0 12px 0;
  color: #2c3e50;
}

.confirm-dialog p {
  margin: 0 0 8px 0;
  color: #6c757d;
}

.warning-text {
  color: #dc3545 !important;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.confirm-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.confirm-actions button {
  flex: 1 1;
  padding: 10px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-actions .cancel-btn {
  background: #e9ecef;
  color: #495057;
}

.confirm-actions .cancel-btn:hover:not(:disabled) {
  background: #dee2e6;
}

.delete-confirm-btn {
  background: #dc3545;
  color: white;
}

.delete-confirm-btn:hover:not(:disabled) {
  background: #c82333;
}

.delete-confirm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================================
   ЗАГРУЗКА
============================================ */

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #336791;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ============================================
   АДАПТИВНОСТЬ
============================================ */

@media (max-width: 768px) {
  .postgresql-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .server-stats {
    grid-template-columns: 1fr;
  }
  
  .databases-grid {
    grid-template-columns: 1fr;
  }
  
  .security-info {
    grid-template-columns: 1fr;
  }
  
  .filter-section {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .container-filter {
    width: 100%;
  }
  
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .modal-content {
    width: 95%;
    margin: 10px;
  }
  
  .card-actions {
    grid-template-columns: 1fr;
  }
  
  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .info-label {
    width: auto;
  }
}

/* PostgreSQLComponents.css */

/* Стили для кликабельных ссылок на базы данных */
.db-name-link {
  color: #0066cc;
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s;
}

.db-name-link:hover {
  color: #004999;
  text-decoration: underline;
}

/* Стили для кликабельных ссылок на контейнеры */
.container-link {
  color: #0066cc;
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s;
}

.container-link:hover {
  color: #004999;
  text-decoration: underline;
}

/* Дополнительные стили для карточки базы данных */
.db-container {
  display: flex;
  align-items: center;
  gap: 4px;
}

.db-container i {
  color: #666;
  font-size: 12px;
}

/* Улучшение отображения списка баз данных в карточке контейнера */
.databases-items {
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 4px;
  margin-top: 5px;
}

.database-item {
  transition: background-color 0.2s;
}

.database-item:hover {
  background-color: #f0f0f0;
}

.db-info {
  display: flex;
  align-items: center;
  gap: 6px;
}

.db-details {
  display: flex;
  gap: 8px;
  font-size: 11px;
  color: #666;
  margin-left: 20px;
  margin-top: 2px;
}

.db-status {
  display: inline-block;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 10px;
}

.db-status.active {
  color: #28a745;
}

.db-status.error {
  color: #dc3545;
}

/* Анимация для ссылок */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}

.db-name-link:active,
.container-link:active {
  animation: pulse 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/components/PostgreSQLComponents.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;;8CAE8C;;AAE9C;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;8CAE8C;;AAE9C;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;8CAE8C;;AAE9C;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;8CAE8C;;AAE9C;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;;8CAE8C;;AAE9C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;8CAE8C;;AAE9C;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;;8CAE8C;;AAE9C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;8CAE8C;;AAE9C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;8CAE8C;;AAE9C;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;EAGE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;8CAE8C;;AAE9C;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;8CAE8C;;AAE9C;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;8CAE8C;;AAE9C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;8CAE8C;;AAE9C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;8CAE8C;;AAE9C;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,6BAA6B;;AAE7B,iDAAiD;AACjD;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,kEAAkE;AAClE;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B","sourcesContent":["/* frontend/src/components/PostgreSQLComponents.css */\r\n\r\n/* ============================================\r\n   ОСНОВНЫЕ СТИЛИ ДЛЯ PostgreSQL MANAGER\r\n============================================ */\r\n\r\n.postgresql-container {\r\n  padding: 24px;\r\n  max-width: 1600px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.postgresql-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.header-left h2 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n}\r\n\r\n.header-left h2 i {\r\n  margin-right: 12px;\r\n  color: #336791;\r\n}\r\n\r\n.server-status {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 6px 12px;\r\n  border-radius: 20px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.server-status.healthy {\r\n  color: #28a745;\r\n  background: #e8f5e9;\r\n}\r\n\r\n.server-status.unhealthy {\r\n  color: #dc3545;\r\n  background: #ffebee;\r\n}\r\n\r\n.server-status i {\r\n  margin-right: 6px;\r\n}\r\n\r\n.create-db-btn {\r\n  background: linear-gradient(135deg, #336791 0%, #2c5a7a 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 12px 24px;\r\n  border-radius: 8px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\r\n}\r\n\r\n.create-db-btn:hover:not(:disabled) {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 12px rgba(0,0,0,0.15);\r\n}\r\n\r\n.create-db-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n  background: #95a5a6;\r\n}\r\n\r\n/* ============================================\r\n   СТАТИСТИКА СЕРВЕРА\r\n============================================ */\r\n\r\n.server-stats {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\r\n  gap: 20px;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.stat-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\r\n  transition: all 0.3s;\r\n}\r\n\r\n.stat-card:hover {\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.stat-icon {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 12px;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n  font-size: 24px;\r\n}\r\n\r\n.stat-content {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.stat-label {\r\n  font-size: 13px;\r\n  color: #6c757d;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.stat-value {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n  line-height: 1.2;\r\n}\r\n\r\n/* ============================================\r\n   ФИЛЬТР ПО КОНТЕЙНЕРАМ\r\n============================================ */\r\n\r\n.filter-section {\r\n  margin-bottom: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.filter-section label {\r\n  font-weight: 500;\r\n  color: #495057;\r\n}\r\n\r\n.container-filter {\r\n  padding: 8px 12px;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  min-width: 250px;\r\n  background: white;\r\n}\r\n\r\n/* ============================================\r\n   СЕТКА БАЗ ДАННЫХ\r\n============================================ */\r\n\r\n.databases-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));\r\n  gap: 24px;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n/* ============================================\r\n   ПУСТОЕ СОСТОЯНИЕ\r\n============================================ */\r\n\r\n.empty-state {\r\n  text-align: center;\r\n  padding: 60px 20px;\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\r\n}\r\n\r\n.empty-icon {\r\n  color: #dee2e6;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.empty-state h3 {\r\n  color: #2c3e50;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.empty-state p {\r\n  color: #6c757d;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.create-first-db-btn {\r\n  background: linear-gradient(135deg, #28a745 0%, #218838 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 12px 28px;\r\n  border-radius: 8px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.create-first-db-btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 12px rgba(0,0,0,0.15);\r\n}\r\n\r\n.warning-message {\r\n  background: #fff3cd;\r\n  border: 1px solid #ffeeba;\r\n  color: #856404;\r\n  padding: 16px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.warning-message i {\r\n  font-size: 24px;\r\n}\r\n\r\n/* ============================================\r\n   ИНФОРМАЦИЯ О БЕЗОПАСНОСТИ\r\n============================================ */\r\n\r\n.security-info {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\r\n  gap: 24px;\r\n  margin-top: 40px;\r\n}\r\n\r\n.info-card {\r\n  background: #f8f9fa;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  display: flex;\r\n  gap: 16px;\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.info-card i {\r\n  font-size: 32px;\r\n  color: #336791;\r\n}\r\n\r\n.info-card h4 {\r\n  margin: 0 0 8px 0;\r\n  color: #2c3e50;\r\n}\r\n\r\n.info-card p {\r\n  margin: 0;\r\n  color: #6c757d;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* ============================================\r\n   КАРТОЧКА БАЗЫ ДАННЫХ\r\n============================================ */\r\n\r\n.database-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\r\n  overflow: hidden;\r\n  transition: all 0.3s;\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.database-card:hover {\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.database-card.active {\r\n  border-left: 4px solid #28a745;\r\n}\r\n\r\n.database-card.error {\r\n  border-left: 4px solid #dc3545;\r\n}\r\n\r\n.card-header {\r\n  padding: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.db-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 8px;\r\n  background: linear-gradient(135deg, #336791 0%, #2c5a7a 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: white;\r\n  font-size: 20px;\r\n}\r\n\r\n.db-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.db-name {\r\n  margin: 0 0 4px 0;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.db-alias {\r\n  color: #6c757d;\r\n  font-size: 13px;\r\n  cursor: help;\r\n}\r\n\r\n.db-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 13px;\r\n}\r\n\r\n.db-container {\r\n  color: #6c757d;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.db-container i {\r\n  font-size: 12px;\r\n}\r\n\r\n.db-status {\r\n  font-weight: 500;\r\n}\r\n\r\n.expand-btn {\r\n  background: none;\r\n  border: none;\r\n  color: #6c757d;\r\n  cursor: pointer;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 6px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.expand-btn:hover {\r\n  background: #f8f9fa;\r\n  color: #336791;\r\n}\r\n\r\n.card-stats {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 12px;\r\n  padding: 16px;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.stat {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n\r\n.stat i {\r\n  color: #6c757d;\r\n  margin-bottom: 4px;\r\n  font-size: 14px;\r\n}\r\n\r\n.stat-value {\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n  font-size: 16px;\r\n}\r\n\r\n.stat-label {\r\n  font-size: 11px;\r\n  color: #6c757d;\r\n  margin-top: 2px;\r\n}\r\n\r\n.card-details {\r\n  padding: 16px;\r\n  border-top: 1px solid #e9ecef;\r\n  background: white;\r\n}\r\n\r\n.details-section {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.details-section h4 {\r\n  margin: 0 0 12px 0;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #495057;\r\n}\r\n\r\n.details-grid {\r\n  display: grid;\r\n  gap: 8px;\r\n}\r\n\r\n.detail-row {\r\n  display: flex;\r\n  font-size: 13px;\r\n}\r\n\r\n.detail-label {\r\n  width: 120px;\r\n  color: #6c757d;\r\n}\r\n\r\n.detail-value {\r\n  flex: 1;\r\n  color: #2c3e50;\r\n  font-family: monospace;\r\n}\r\n\r\n.db-description {\r\n  margin: 0;\r\n  padding: 8px;\r\n  background: #f8f9fa;\r\n  border-radius: 6px;\r\n  color: #495057;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.security-badge {\r\n  background: #e8f4f8;\r\n  border-radius: 6px;\r\n  padding: 12px;\r\n  margin-bottom: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 13px;\r\n  color: #0d47a1;\r\n}\r\n\r\n.security-badge i {\r\n  font-size: 18px;\r\n}\r\n\r\n.card-actions {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 12px;\r\n}\r\n\r\n.action-btn {\r\n  padding: 10px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.reset-password-btn {\r\n  background: #e3f2fd;\r\n  color: #0d47a1;\r\n}\r\n\r\n.reset-password-btn:hover:not(:disabled) {\r\n  background: #bbdefb;\r\n}\r\n\r\n.reset-password-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.delete-btn {\r\n  background: #ffebee;\r\n  color: #c62828;\r\n}\r\n\r\n.delete-btn:hover:not(:disabled) {\r\n  background: #ffcdd2;\r\n}\r\n\r\n.delete-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ============================================\r\n   МОДАЛЬНОЕ ОКНО\r\n============================================ */\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  max-width: 600px;\r\n  width: 90%;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 10px 40px rgba(0,0,0,0.2);\r\n}\r\n\r\n.postgres-modal {\r\n  max-width: 600px;\r\n}\r\n\r\n.modal-header {\r\n  padding: 20px;\r\n  border-bottom: 1px solid #e9ecef;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  position: sticky;\r\n  top: 0;\r\n  background: white;\r\n  z-index: 10;\r\n}\r\n\r\n.modal-header h3 {\r\n  margin: 0;\r\n  color: #2c3e50;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.modal-header h3 i {\r\n  color: #336791;\r\n}\r\n\r\n.close-modal-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: #6c757d;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 6px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.close-modal-btn:hover:not(:disabled) {\r\n  background: #f8f9fa;\r\n  color: #dc3545;\r\n}\r\n\r\n.close-modal-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ============================================\r\n   ФОРМЫ\r\n============================================ */\r\n\r\nform {\r\n  padding: 20px;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n  margin-bottom: 6px;\r\n  font-weight: 500;\r\n  color: #495057;\r\n}\r\n\r\n.form-group input,\r\n.form-group select,\r\n.form-group textarea {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group select:focus,\r\n.form-group textarea:focus {\r\n  outline: none;\r\n  border-color: #336791;\r\n  box-shadow: 0 0 0 3px rgba(51, 103, 145, 0.1);\r\n}\r\n\r\n.form-group input:disabled,\r\n.form-group select:disabled,\r\n.form-group textarea:disabled {\r\n  background: #e9ecef;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 16px;\r\n}\r\n\r\n.input-hint {\r\n  display: block;\r\n  margin-top: 4px;\r\n  color: #6c757d;\r\n  font-size: 12px;\r\n}\r\n\r\n.container-select {\r\n  width: 100%;\r\n  padding: 10px;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  background: white;\r\n}\r\n\r\n.container-info-hint {\r\n  margin-top: 8px;\r\n  padding: 8px 12px;\r\n  background: #e3f2fd;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  color: #0d47a1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.error-message {\r\n  background: #f8d7da;\r\n  border: 1px solid #f5c6cb;\r\n  color: #721c24;\r\n  padding: 12px;\r\n  border-radius: 6px;\r\n  margin-bottom: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.info-box {\r\n  background: #e7f3ff;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  margin-bottom: 20px;\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.info-box i {\r\n  font-size: 24px;\r\n  color: #336791;\r\n}\r\n\r\n.info-box.important {\r\n  background: #fff3e0;\r\n  border-left: 4px solid #ff9800;\r\n}\r\n\r\n.info-box.important i {\r\n  color: #ff9800;\r\n}\r\n\r\n.info-box ul {\r\n  margin: 8px 0 0 0;\r\n  padding-left: 20px;\r\n}\r\n\r\n.info-box li {\r\n  margin: 4px 0;\r\n  color: #495057;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  margin-top: 24px;\r\n}\r\n\r\n.cancel-btn {\r\n  padding: 10px 20px;\r\n  border: 1px solid #dee2e6;\r\n  background: white;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.cancel-btn:hover:not(:disabled) {\r\n  background: #f8f9fa;\r\n}\r\n\r\n.submit-btn {\r\n  padding: 10px 24px;\r\n  background: linear-gradient(135deg, #336791 0%, #2c5a7a 100%);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.submit-btn:hover:not(:disabled) {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\r\n}\r\n\r\n.submit-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ============================================\r\n   ПРОГРЕСС СОЗДАНИЯ\r\n============================================ */\r\n\r\n.creation-progress {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n}\r\n\r\n.progress-spinner {\r\n  position: relative;\r\n  width: 100px;\r\n  height: 100px;\r\n  margin: 0 auto 30px;\r\n}\r\n\r\n.progress-spinner .fa-database {\r\n  color: #336791;\r\n}\r\n\r\n.progress-spinner .fa-cog {\r\n  position: absolute;\r\n  bottom: -10px;\r\n  right: -10px;\r\n  color: #ff9800;\r\n}\r\n\r\n.cog-spin {\r\n  animation: spin 2s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.progress-text h4 {\r\n  color: #2c3e50;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.progress-text p {\r\n  color: #6c757d;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.progress-steps {\r\n  max-width: 400px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.progress-step-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n  text-align: left;\r\n}\r\n\r\n.step-indicator {\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 50%;\r\n  background: #e9ecef;\r\n  transition: all 0.3s;\r\n}\r\n\r\n.step-indicator.active {\r\n  background: #28a745;\r\n  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.2);\r\n}\r\n\r\n.step-label {\r\n  color: #495057;\r\n  font-size: 14px;\r\n}\r\n\r\n/* ============================================\r\n   УСПЕШНОЕ СОЗДАНИЕ\r\n============================================ */\r\n\r\n.creation-success {\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n\r\n.success-icon {\r\n  color: #28a745;\r\n  font-size: 64px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.database-info {\r\n  text-align: left;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  margin: 20px 0;\r\n}\r\n\r\n.database-info h4 {\r\n  margin: 0 0 16px 0;\r\n  color: #2c3e50;\r\n  text-align: center;\r\n}\r\n\r\n.info-block {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.info-row {\r\n  display: flex;\r\n  padding: 8px 0;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.info-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.info-label {\r\n  width: 120px;\r\n  font-weight: 500;\r\n  color: #6c757d;\r\n}\r\n\r\n.info-value {\r\n  flex: 1;\r\n  color: #2c3e50;\r\n  font-family: monospace;\r\n}\r\n\r\n.security-note {\r\n  background: #e3f2fd;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-top: 16px;\r\n}\r\n\r\n.security-note i {\r\n  font-size: 24px;\r\n  color: #0d47a1;\r\n}\r\n\r\n.security-note strong {\r\n  display: block;\r\n  margin-bottom: 4px;\r\n  color: #0d47a1;\r\n}\r\n\r\n.security-note p {\r\n  margin: 4px 0;\r\n  color: #1a237e;\r\n  font-size: 14px;\r\n}\r\n\r\n.security-note .small {\r\n  font-size: 13px;\r\n  opacity: 0.8;\r\n}\r\n\r\n/* ============================================\r\n   ДИАЛОГ ПОДТВЕРЖДЕНИЯ УДАЛЕНИЯ\r\n============================================ */\r\n\r\n.confirm-dialog {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1100;\r\n}\r\n\r\n.confirm-dialog-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  max-width: 400px;\r\n  width: 90%;\r\n  text-align: center;\r\n}\r\n\r\n.confirm-icon {\r\n  color: #ffc107;\r\n  font-size: 48px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.confirm-dialog h4 {\r\n  margin: 0 0 12px 0;\r\n  color: #2c3e50;\r\n}\r\n\r\n.confirm-dialog p {\r\n  margin: 0 0 8px 0;\r\n  color: #6c757d;\r\n}\r\n\r\n.warning-text {\r\n  color: #dc3545 !important;\r\n  font-size: 13px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n}\r\n\r\n.confirm-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.confirm-actions button {\r\n  flex: 1;\r\n  padding: 10px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.confirm-actions .cancel-btn {\r\n  background: #e9ecef;\r\n  color: #495057;\r\n}\r\n\r\n.confirm-actions .cancel-btn:hover:not(:disabled) {\r\n  background: #dee2e6;\r\n}\r\n\r\n.delete-confirm-btn {\r\n  background: #dc3545;\r\n  color: white;\r\n}\r\n\r\n.delete-confirm-btn:hover:not(:disabled) {\r\n  background: #c82333;\r\n}\r\n\r\n.delete-confirm-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ============================================\r\n   ЗАГРУЗКА\r\n============================================ */\r\n\r\n.loading-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px 20px;\r\n}\r\n\r\n.spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 3px solid #f3f3f3;\r\n  border-top: 3px solid #336791;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n/* ============================================\r\n   АДАПТИВНОСТЬ\r\n============================================ */\r\n\r\n@media (max-width: 768px) {\r\n  .postgresql-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 16px;\r\n  }\r\n  \r\n  .server-stats {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .databases-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .security-info {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .filter-section {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .container-filter {\r\n    width: 100%;\r\n  }\r\n  \r\n  .form-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .modal-content {\r\n    width: 95%;\r\n    margin: 10px;\r\n  }\r\n  \r\n  .card-actions {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .info-row {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .info-label {\r\n    width: auto;\r\n  }\r\n}\r\n\r\n/* PostgreSQLComponents.css */\r\n\r\n/* Стили для кликабельных ссылок на базы данных */\r\n.db-name-link {\r\n  color: #0066cc;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.db-name-link:hover {\r\n  color: #004999;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Стили для кликабельных ссылок на контейнеры */\r\n.container-link {\r\n  color: #0066cc;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.container-link:hover {\r\n  color: #004999;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Дополнительные стили для карточки базы данных */\r\n.db-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.db-container i {\r\n  color: #666;\r\n  font-size: 12px;\r\n}\r\n\r\n/* Улучшение отображения списка баз данных в карточке контейнера */\r\n.databases-items {\r\n  background-color: #f8f9fa;\r\n  border-radius: 4px;\r\n  padding: 4px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.database-item {\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.database-item:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.db-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.db-details {\r\n  display: flex;\r\n  gap: 8px;\r\n  font-size: 11px;\r\n  color: #666;\r\n  margin-left: 20px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.db-status {\r\n  display: inline-block;\r\n  padding: 2px 4px;\r\n  border-radius: 3px;\r\n  font-size: 10px;\r\n}\r\n\r\n.db-status.active {\r\n  color: #28a745;\r\n}\r\n\r\n.db-status.error {\r\n  color: #dc3545;\r\n}\r\n\r\n/* Анимация для ссылок */\r\n@keyframes pulse {\r\n  0% { opacity: 1; }\r\n  50% { opacity: 0.7; }\r\n  100% { opacity: 1; }\r\n}\r\n\r\n.db-name-link:active,\r\n.container-link:active {\r\n  animation: pulse 0.3s ease;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
